import React, { useEffect, useState } from 'react';
import { FontAwesome5 } from '@expo/vector-icons';
import { TouchableOpacity, View, Text } from 'react-native';

import { getLocationsData, deleteLocation } from '../../../api/Settings';
import { msgStr } from '../../../common/constants/Message';
import { TextMediumSize } from '../../../common/constants/Fonts';
import { useAlertModal, useConfirmModal } from '../../../common/hooks';
import { BasicLayout, CommonContainer } from '../../../common/components/CustomLayout';
import { BOHTBody, BOHTD, BOHTDIconBox, BOHTH, BOHTHead, BOHTR, BOHTable } from '../../../common/components/bohtable';
import { BOHToolbar, BOHButton } from '../../../common/components/bohtoolbar';
import Select from '../../../common/components/ui/Select';
import { getBrandsData } from '../../../api/Price';

import AddStoreLocationModal from './AddStoreLocationModal';

const Locations = ({ navigation, openInventory }) => {
  const { showAlert } = useAlertModal();
  const { showConfirm } = useConfirmModal();

  const [tableData, setTableData] = useState([]);
  const [updateLocationTrigger, setUpdateLocationsTrigger] = useState(true);
  const InitialWidths = [160, 220, 100, 120, 140, 80, 90, 140, 180, 50, 50];

  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [brands, setBrands] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState(null);

  const openAddLocationModal = () => {
    setAddModalVisible(true);
    setSelectedLocation(null);
  };
  const closeAddLocationModal = () => {
    setAddModalVisible(false);
    setSelectedLocation(null);
  };
  const editLocation = (item) => {
    setSelectedLocation(item);
    setAddModalVisible(true);
  };

  useEffect(() => {
    if (updateLocationTrigger == true) getTable();
  }, [updateLocationTrigger]);

  useEffect(() => {
    getBrandsData((jsonRes, status, error) => {
      if (status === 200) {
        setBrands([
          { label: 'All Brands', value: null },
          ...jsonRes.map((item) => ({ label: item.brand, value: item.id }))
        ]);
      }
    });
  }, []);

  const removeLocation = (id) => {
    showConfirm(msgStr('deleteConfirmStr'), () => {
      deleteLocation(id, (jsonRes, status, error) => {
        switch (status) {
          case 200:
            setUpdateLocationsTrigger(true);
            showAlert('success', jsonRes.message);
            break;
          default:
            if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
            else showAlert('error', msgStr('unknownError'));
            break;
        }
      });
    });
  };

  const getTable = () => {
    getLocationsData({includeBrands: true}, (jsonRes, status, error) => {
      switch (status) {
        case 200:
          setUpdateLocationsTrigger(false);
          setTableData(jsonRes);
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  const renderTableData = () => {
    const rows = [];
    const renderBrands = (locationStores) => {
      if (!locationStores || locationStores.length === 0) return <Text>-</Text>;
      let filteredStores = locationStores;
      if (selectedBrandId) {
        filteredStores = locationStores.filter(store => {
          const brandId = store?.brand_id || store?.brands?.id;
          return Number(brandId) === Number(selectedBrandId);
        });
      }
      const brands = filteredStores
        .map((store) => store?.brands?.brand)
        .filter(Boolean);
      
      if (brands.length === 0) return <Text>-</Text>;
      
      return (
        <View>
          <Text style={{ fontSize: 10, fontWeight: '600', color: '#666' }}>Linked Brands:</Text>
          {brands.map((brand, idx) => (
            <Text key={idx} style={{ fontSize: 10, color: '#dc2626', marginTop: 2 }}>
              {brand}
            </Text>
          ))}
        </View>
      );
    };
    const renderValue = (value) => (value === null || value === undefined || value === '' ? '-' : value);
    
    const filteredData = selectedBrandId
      ? tableData.filter((item) =>
          item.locationStores?.some((store) => {
            const brandId = store?.brand_id || store?.brands?.id;
            return Number(brandId) === Number(selectedBrandId);
          })
        )
      : tableData;

    if (filteredData.length > 0) {
      filteredData.map((item, index) => {
        rows.push(
          <BOHTR key={index}>
            <BOHTD width={InitialWidths[0]}>{renderValue(item.name)}</BOHTD>
            <BOHTD width={InitialWidths[1]}>{item.location}</BOHTD>
            <BOHTD width={InitialWidths[2]}>{renderValue(item.location_type)}</BOHTD>
            <BOHTD width={InitialWidths[3]}>{renderValue(item.location_group)}</BOHTD>
            <BOHTD width={InitialWidths[4]}>{renderValue(item.city)}</BOHTD>
            <BOHTD width={InitialWidths[5]}>{renderValue(item.state)}</BOHTD>
            <BOHTD width={InitialWidths[6]}>{item.is_driveoff_location ? 'Yes' : 'No'}</BOHTD>
            <BOHTD width={InitialWidths[7]}>{renderValue(item.plantation?.plantation)}</BOHTD>
            <BOHTD width={InitialWidths[8]}>{renderBrands(item.locationStores)}</BOHTD>
            <BOHTDIconBox  width={InitialWidths[9]}>
              <TouchableOpacity
                onPress={() => {
                  editLocation(item);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="edit" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
            <BOHTDIconBox  width={InitialWidths[10]}>
              <TouchableOpacity
                onPress={() => {
                  removeLocation(item.id);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="times" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
          </BOHTR>
        );
      });
    } else {
      <></>;
    }
    return <>{rows}</>;
  };

  return (
    <BasicLayout
      navigation={navigation}
      goBack={() => {
        openInventory(null);
      }}
      screenName={'Store Locations'}
    >
      <CommonContainer>
        <BOHToolbar>
          <BOHButton 
            label={"Add"}
            onPress={openAddLocationModal}/>
          <Select
            label={""}
            options={brands}
            value={selectedBrandId}
            onChange={(newValue) => setSelectedBrandId(newValue)}
            placeholder="Select Brand"
            customStyle={{
              container: { marginLeft: 16, width: 250 },
              input: { marginTop: 0, marginBottom: 0, borderRadius: 4 }
            }}
          />
        </BOHToolbar>
        <BOHTable>
          <BOHTHead>
            <BOHTR>
              <BOHTH width={InitialWidths[0]}>{'Name'}</BOHTH>
              <BOHTH width={InitialWidths[1]}>{'Location'}</BOHTH>
              <BOHTH width={InitialWidths[2]}>{'Type'}</BOHTH>
              <BOHTH width={InitialWidths[3]}>{'Belongs To'}</BOHTH>
              <BOHTH width={InitialWidths[4]}>{'City'}</BOHTH>
              <BOHTH width={InitialWidths[5]}>{'State'}</BOHTH>
              <BOHTH width={InitialWidths[6]}>{'Drive Off'}</BOHTH>
              <BOHTH width={InitialWidths[7]}>{'Area/Plantation'}</BOHTH>
              <BOHTH width={InitialWidths[8]}>{'Brands'}</BOHTH>
              <BOHTH width={InitialWidths[9]}>{'Edit'}</BOHTH>
              <BOHTH width={InitialWidths[10]}>{'DEL'}</BOHTH>
            </BOHTR>
          </BOHTHead>
          <BOHTBody>
            {renderTableData()}
          </BOHTBody>
        </BOHTable>
        <AddStoreLocationModal
          isModalVisible={isAddModalVisible}
          Location={selectedLocation}
          setUpdateLocationsTrigger={setUpdateLocationsTrigger}
          closeModal={closeAddLocationModal}
        />
      </CommonContainer>
    </BasicLayout>
  );
};

export default Locations;
